import {
  MockMap,
} from '@ama-sdk/core';
import {
  createMockData,
} from '@dapi/sdk/spec';
import {
  alternativeOfferConfirmationJobMock,
  alternativeOfferInProgressJobMock,
  getAlternativeOffersMockDisruptedOutboundForLostServices,
  retrieveOrderMockDisruptedInBoundsWithLostServices,
  retrieveOrderMockDisruptedMultiBoundsWithLostServices,
  retrieveOrderMockReaccomodatedMultiBoundsWithLostServices,
} from '../../../mock/data/index';
import {
  lostServiceWarning,
} from '../../../mock/dictionaries/index';

const warnings = [lostServiceWarning];
export const disruptedMultiboundsWithLostServicesMock: MockMap = {
  retrieveOrder: [
    createMockData(retrieveOrderMockDisruptedMultiBoundsWithLostServices, [], warnings),
    createMockData(retrieveOrderMockDisruptedInBoundsWithLostServices, [], warnings),
    createMockData(retrieveOrderMockReaccomodatedMultiBoundsWithLostServices, [], warnings)
  ],
  getOrderEligibilities: [],
  getAlternativeOffers: [
    {
      mockData: getAlternativeOffersMockDisruptedOutboundForLostServices
    }
  ],
  createAsynchronousJobForAlternativeOfferConfirmation: [createMockData(alternativeOfferInProgressJobMock)],
  getAlternativeOfferConfirmationJob: [createMockData(alternativeOfferConfirmationJobMock)],
  acknowledge: [createMockData({})]
};
